import { render } from "./Gallery.vue?vue&type=template&id=2dc25094&scoped=true"
const script = {}

import "./Gallery.vue?vue&type=style&index=0&id=2dc25094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc25094"]])

export default __exports__